import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=7b2f0fb8&scoped=true&"
import script from "./exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition.vue?vue&type=script&lang=js&"
import style0 from "./exhibition.scss?vue&type=style&index=0&id=7b2f0fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f0fb8",
  null
  
)

export default component.exports